import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Form } from 'react-final-form'
import { withRouter } from 'react-router'
import compose from '@shopify/react-compose'
import { FORM_ERROR } from 'final-form'
import { withTranslation } from 'react-i18next'

import ValidationCodeView from './validation-code-view'
import { confirmPhoneNumberCode, resendPhoneNumberChangeCode, confirmationCodeValidator } from '@portal/kit/pkg/services'

const RESEND_STATUSES = {
  UNRESOLVED: null,
  SUCCESS: 'success',
  ERROR: 'error',
  LIMIT_REACHED: 'limit-reached',
}

class ValidationCodeContainer extends Component {
  state = {
    resendStatus: RESEND_STATUSES.UNRESOLVED,
  }

  validateCode = async (values) => {
    try {
      const response = await confirmPhoneNumberCode(values.code)

      this.props.history.push('/my-account', {
        notification: {
          status: 'success',
          message: 'account.phone_number.updated'
        }
      })

      this.props.user.setUser(response.data)
    }
    catch(e) {
      return { [FORM_ERROR]: e.response && e.response.status === 422 ? this.props.t('account.phone_number.code.invalid') : this.props.t('form.error') }
    }
  }

  resendCode = async () => {
    try {
      await resendPhoneNumberChangeCode()
      this.setState({ resendStatus: RESEND_STATUSES.SUCCESS })
    }
    catch(e) {
      let resendStatus = RESEND_STATUSES.ERROR

      if (e.response && e.response.data && e.response.data.errors) {
        const codes = Object.keys(e.response.data.errors).map(field =>
          e.response.data.errors[field].map(error => error.code)
        ).flat()

        if (codes.indexOf('limit_reached') > -1) {
          resendStatus = RESEND_STATUSES.LIMIT_REACHED
        }
      }

      this.setState({ resendStatus })
    }
  }

  render() {
    return (
      <Form
        onSubmit={this.validateCode}
        validate={confirmationCodeValidator}
        render={formProps => (
          <ValidationCodeView
            {...formProps}
            resendCode={this.resendCode}
            resendStatus={this.state.resendStatus}
            resendStatuses={RESEND_STATUSES}
            previousStep={this.props.previousStep}
            user={this.props.user.data}
          />
        )}
      />
    )
  }
}

ValidationCodeContainer.propTypes = {
  user: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
}

export default compose(
  withRouter,
  withTranslation(),
)(ValidationCodeContainer)
